// extracted by mini-css-extract-plugin
module.exports = {"add_new_detail":"form-readiness_add_new_detail__3QliF","mainTitle":"form-readiness_mainTitle__2WYGv","subText":"form-readiness_subText__32KM5"};